import jwtDecode from 'jwt-decode';

/**
 * author andre.pitombeira
 */
/** @ngInject */
export default function SigninController(
  $scope,
  $rootScope,
  $state,
  $window,
  $http,
  AUTHENTICATION,
  sessionService,
  AuthenticationService,
  NotificationService,
  environmentService,
) {
  var vm = this;

  vm.user = {};
  vm.submited = false;

  vm.signin = signin;
  vm.allowLogInWithPassword = false;
  vm.googleClientId = '';

  $window.handleCredentialResponse = function(response) {
    var decodedToken = jwtDecode(response.credential);

    $http
      .post(AUTHENTICATION.SESSIONS + '/tokenSignIn', { idToken: response.credential })
      .then(handleSigninSuccess)
      .catch(function() {
        NotificationService.error('No account for ' + decodedToken.email + ' Exists');
      });
  };

  window.onload = function() {
    setGoogleButton();
  };


  $scope.init = () => {
    vm.allowLogInWithPassword = !environmentService.isBetaOrProduction();
    vm.googleClientId = environmentService.getEnvironment().GOOGLE_CLIENT_ID;
    setGoogleButton();
  };

  $scope.init();

  function setGoogleButton() {
    if (window.google && vm.googleClientId) {
      window.google.accounts.id.initialize({
        'client_id': vm.googleClientId,
        'callback': $window.handleCredentialResponse,
      });
      const buttonContainer = angular.element(document.querySelector('#signin-with-google-container'))[0];
      window.google.accounts.id.renderButton(buttonContainer, {
        size: 'medium',
        type: 'standard',
      });
    }
  }

  function signin(isFormValid) {
    if (!isFormValid) {
      vm.submited = true;
      return;
    }

    AuthenticationService.signin(vm.user).then(
      function(res) {
        handleSigninSuccess(res);
      },
      function() {
        NotificationService.error('Invalid Login or Password');
      },
    );
  }

  function handleSigninSuccess(res) {
    if (!(res && res.data)) {
      return;
    }

    sessionService.createSession(res.data);
    NotificationService.success('You have successfully logged in');
    $state.go('app.dashboard');
    $rootScope.$broadcast('signin.successful');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/signin/signin.controller.js